import { useCallback, useState } from 'react';

import { useGetPrinterListQuery } from 'src/redux/api/connectInstance';

export const usePrinters = (connectionId?: number) => {
  const [requested, setIsReuested] = useState(false);

  const { data, isLoading, refetch } = useGetPrinterListQuery(
    connectionId || 0,
    { skip: !connectionId || !requested },
  );

  const getPrintersData = useCallback(() => {
    if (!requested) {
      setIsReuested(true);
    }

    return {
      printers: data?.printers,
      defaultPrinter: data?.printers?.find(({ isDefault }) => !!isDefault),
      isLoading,
      refetch,
    };
  }, [data, requested, isLoading, refetch]);

  return { getPrintersData };
};
